const urlRequest = 'https://wine-3qu5.vercel.app/api'

export default urlRequest
